export default "__VITE_ASSET__CJBxGWpG__"